"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticsearchEnum = exports.ElasticsearchHostNoHttpsEnum = void 0;
var ElasticsearchHostNoHttpsEnum;
(function (ElasticsearchHostNoHttpsEnum) {
    ElasticsearchHostNoHttpsEnum["Klear"] = "search-klear-5bw4e2qlbfbghtlx4ooo4g7ojq.eu-west-1.es.amazonaws.com";
    ElasticsearchHostNoHttpsEnum["KlearDev"] = "search-dev-i7m47fzvesz4m7zfqhn4abkul4.eu-west-1.es.amazonaws.com";
    ElasticsearchHostNoHttpsEnum["ChineseProd"] = "vpc-chinese-networks-4qeidrr4b73fhyernuojrreaqy.eu-west-1.es.amazonaws.com";
})(ElasticsearchHostNoHttpsEnum = exports.ElasticsearchHostNoHttpsEnum || (exports.ElasticsearchHostNoHttpsEnum = {}));
var ElasticsearchEnum;
(function (ElasticsearchEnum) {
    ElasticsearchEnum["Klear"] = "Klear";
    ElasticsearchEnum["KlearDev"] = "KlearDev";
    ElasticsearchEnum["ChineseProd"] = "ChineseProd";
})(ElasticsearchEnum = exports.ElasticsearchEnum || (exports.ElasticsearchEnum = {}));
//# sourceMappingURL=elasticsearchHostNoHttps.enum.js.map